module.exports = __webpack_public_path__ + "img/696.9d7906bd.jpg";